import { env } from '@/env';
import { getSessionValues } from '@/providers/session-provider/get-session-values';

export function getHeaders() {
  const { token, userId, customerId, organizationId, segments } =
    getSessionValues();

  if (!token || !userId || !customerId || !organizationId) {
    return {};
  }

  return {
    headers: {
      Authorization: `Token ${token}`,
      'X-PIGELLO-USER-ID': userId,
      ...(segments.length > 0 && {
        'X-PIGELLO-CHOSEN-SEGMENT': segments.join(','),
      }),
      'X-PIGELLO-CUSTOMER-ID': customerId,
      // env,client-type,version
      'X-PIGELLO-CLIENT-TYPE': `${env.NEXT_PUBLIC_CLIENT_TYPE},frontend,1.0.0`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
}
